class CommunitySocialAnalytics {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/community/social-analytics`;
    this.apiClient = apiClient;

  }

  // getDashboard returns the whole analytics page in one read: overview, insights,
  // per-channel summaries, series and metric definitions. Opening the dashboard must not
  // fan out into one request per network per metric family.
  async getDashboard(range) {

    const path = this.basePath + '/dashboard';

    return this.apiClient.get(path, {}, {
      filterOptions: {
        startDate: range.startDate,
        endDate: range.endDate
      }
    });

  }

  async getAccounts() {

    const path = this.basePath + '/accounts';

    return this.apiClient.get(path, {}, {});

  }

  // refresh schedules the same collection the daily sweep would run for one network. It
  // returns as soon as the request is queued; the collected data arrives later and reaches
  // the client through the SOCIAL_ANALYTICS_UPDATED event.
  async refresh(network) {

    const path = this.basePath + '/refresh';

    return this.apiClient.post(path, {}, {}, { network });

  }

}

export default CommunitySocialAnalytics;
